import { render, staticRenderFns } from "./TeamDealsWidget.vue?vue&type=template&id=177cf120&scoped=true"
import script from "./TeamDealsWidget.vue?vue&type=script&lang=js"
export * from "./TeamDealsWidget.vue?vue&type=script&lang=js"
import style0 from "./TeamDealsWidget.vue?vue&type=style&index=0&id=177cf120&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "177cf120",
  null
  
)

export default component.exports